import { Provider } from '@angular/core';
import { SupervisorDashboardFacadeService } from './supervisor-dashboard-facade.service';
import { SupervisorDashboardPreferencesService } from './supervisor-dashboard-preferences.service';

export function provideSupervisorDashboard(): Provider[] {
  return [
    SupervisorDashboardFacadeService,
    SupervisorDashboardPreferencesService,
  ];
}
